import { actionTypes as at, actionCreators } from '../actions';
import { ActionType } from 'typesafe-actions';
import Types from 'Types';

export const initialState = {
  data: null,
  loading: false,
};

export type Action = ActionType<typeof actionCreators>;

export const reducer = (state = initialState, { type, payload }: Action & Types.StoreAction) => {
  switch (type) {
      case at.FORGOTTEN_PASSWORD:
        return {
          data: null,
          loading: true,
        }
      case at.FORGOTTEN_PASSWORD_ERROR:
        return {
          ...state,
          loading: false,
          error: payload,
        }
      case at.FORGOTTEN_PASSWORD_SUCCESS:
        return {
          ...state,
          loading: false,
          data: payload,
        }
      default:
        return state;
  }
};

export const isLoading = ({ submitForm: { forgottenPassword } }: Types.StoreState) => forgottenPassword.loading;

export const getData = ({ submitForm: { forgottenPassword } }: Types.StoreState) => forgottenPassword.data;

